// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__Z7F-P","actions":"style_actions__GKcUN","actions_btn":"style_actions_btn__dlBI9"};